function polarToCartesian(
  startx: number,
  starty: number,
  radius: number,
  angleInDegrees: number
): { x: number; y: number } {
  var angleInRadians = ((angleInDegrees - 90) * Math.PI) / 180.0;

  return {
    x: startx + radius * Math.cos(angleInRadians),
    y: starty + radius * Math.sin(angleInRadians),
  };
}

function htmlToElement(html: string): HTMLElement {
  var template = document.createElement("template");
  html = html.trim(); // Never return a text node of whitespace as the result
  template.innerHTML = html;
  return template.content.firstChild as HTMLElement;
}

class Radar {
  size = 50;
  svg: HTMLElement;
  angle: number = 0;
  rotation: number = 0;
  public readonly key: string;
  active: boolean;
  constructor(key: string) {
    this.key = key;
    const template = `<svg width="100" height="100" viewBox="0 0 ${
      this.size * 2
    } ${this.size * 2}" xmlns="http://www.w3.org/2000/svg" id="${this.getId()}">
    <path id="${this.getId(
      "arc"
    )}" fill="cyan" opacity="0.7" stroke="none"></path>
</svg>`;
    this.svg = htmlToElement(template);
  }

  getId(element?: string) {
    let id = `svg-radar-${this.key}`;
    if (element) {
      id = `${id}-${element}`;
    }
    return id;
  }

  getDomElement() {
    return this.svg;
  }

  setAngle(angle: number) {
    this.angle = angle;
    this.draw();
  }

  setRotation(rotation: number) {
    this.rotation = rotation;
    this.draw();
  }

  setActive(val: boolean) {
    this.active = val;
    this.draw();
  }

  getElement(name: string) {
    return document.getElementById(this.getId(name));
  }

  drawInactive() {
    const radius = 0.4;
    this.getElement("arc").setAttribute(
      "d",
      `M ${(1 + radius) * this.size} ${this.size} A ${radius * this.size} ${
        radius * this.size
      } 0 0 1 ${(1 - radius) * this.size} ${this.size}  A ${
        radius * this.size
      } ${radius * this.size} 0 0 1 ${(1 + radius) * this.size} ${this.size}`
    );
  }

  draw() {
    if (this.active) {
      this.drawActive();
    } else {
      this.drawInactive();
    }
  }

  drawActive() {
    const startAngle = this.rotation - this.angle / 2;
    const endAngle = this.rotation + this.angle / 2;
    /*
    let coords = polarToCartesian(this.size, this.size, this.size, startAngle);
    let d = ["M", this.size, this.size, "L", coords.x, coords.y];
    this.getElement("segment1").setAttribute("d", d.join(" "));

    coords = polarToCartesian(this.size, this.size, this.size, endAngle);
    d = ["M", this.size, this.size, "L", coords.x, coords.y];
    this.getElement("segment2").setAttribute("d", d.join(" "));
*/
    const radius = this.size * 0.7;
    let coords = polarToCartesian(this.size, this.size, radius, startAngle);
    let d = ["M", this.size, this.size];
    d.push("L", coords.x, coords.y);
    coords = polarToCartesian(this.size, this.size, radius, endAngle);
    d.push("A", radius, radius, 0, 0, 1, coords.x, coords.y);
    d.push("L", this.size, this.size);
    this.getElement("arc")?.setAttribute("d", d.join(" "));
  }
}

export { Radar };
